import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/app/dialog/dialog";
import DatePicker from "components/app/function/DatePicker";
import NumberInput from "components/app/function/NumberInput";
import SelectGroupRadioOptionSingle from "components/app/function/SelectOneRadioOption";
import TextInput from "components/app/function/TextInput";

import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, Minus, Plus, X } from "lucide-react";
import AdReviewNotice from "pages/news-feed/AdReviewNotice";
import { useEffect, useState } from "react";

import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  post: any;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
}
export default function NewFeedDialogBoostPost({ post, isDialogOpen, setIsDialogOpen }: DialogProps) {
  const { showDialogConfirm } = appStore();
  const { token } = useAppSelector((state) => state.auth);
  const [loadingSubmit, setloadingSubmit] = useState<boolean>(false);
  const today = new Date();
  const [hideDescription, setHideDescription] = useState<Boolean>(false);
  const [gender, setGender] = useState("All");
  const [age, setAge] = useState([18, 65]);
  const [location, setLocation] = useState("");

  const [days, setDays] = useState(7);

  const [endDate, setEndDate] = useState<any>();
  const [message, setMessage] = useState<string>("");

  const submitRunCampaign = async (id: any) => {
    setloadingSubmit(true);
    try {
      let url: string = "";

      url = RouteApi.submitRunCampaign;
      url += `token=${token}`;
      const data = {
        campaign: {
          post_id: id,
          campaign_id: "",
          description: post?.media_title,
          starting_datetime: today,
          ending_datetime: endDate,
          campaign_type: "Awareness",
          pobject_type: "Reach",
          budget_amount: budget,
          age_from: age[0],
          age_to: age[1],
          gender: gender === "All" ? "" : gender,
          // gender==="All"?"":gender,
        },
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setloadingSubmit(false);
            setHideDescription(true);
            // onUploadSuccess({
            //   res: responses.user_shop_product,
            //   name: "delete",
            // });
          } else {
            setMessage(responses.msg);
            setloadingSubmit(false);
          }
        })
        .catch((err) => {
          setloadingSubmit(false);
        });
    } catch (error) {
      setloadingSubmit(false);

      AppLog.show({
        message: `[submitRunCampaign]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    const today = new Date();
    const futureDate = new Date();
    futureDate.setDate(today.getDate() + days);
    setEndDate(futureDate);
  }, [days]);

  useEffect(() => {
    if (!endDate) return;
    const dateObj = new Date(endDate); // ensures it's a Date
    if (isNaN(dateObj.getTime())) return;
    const today = new Date();
    const diffTime = dateObj.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    setDays(diffDays);
  }, [endDate]);

  const [budget, setBudget] = useState<number | null>(null);
  // const handleBudgetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = parseFloat(e.target.value);
  //   const validValue = isNaN(value) || value < 1 ? 1 : value;
  //   setBudget(validValue);
  // };
  const handleBudgetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Allow empty input
    if (value === "") {
      setBudget(null);
      return;
    }

    // Only allow valid numbers
    const parsed = parseFloat(value);
    if (!isNaN(parsed)) {
      setBudget(Math.max(0, parsed));
    }
  };

  return (
    <>
      <Dialog open={isDialogOpen}>
        <DialogContent
          onWheel={(e) => {
            e.stopPropagation();
          }}
          isShowBtnXClose={false}
          className="max-w-full lg:max-w-[800px] h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 "
        >
          <DialogHeader>
            <DialogTitle className=" text-start flex justify-center items-center">Promote Post</DialogTitle>
            <div
              className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
              onClick={() => setIsDialogOpen(false)}
            >
              <X />
            </div>
          </DialogHeader>
          <ScrollArea className="mt-2 gap-3  pr-[20px] pb-[50px]">
            {hideDescription ? (
              <>
                <AdReviewNotice />
              </>
            ) : (
              <>
                {message ? (
                  <p className="p-2 rounded-md">
                    Your campaign is currently undergoing our review process to ensure it meets all guidelines and quality standards. This process typically takes up to 24 hours.
                    We appreciate your patience and will notify you as soon as the review is complete.
                  </p>
                ) : (
                  <>
                    <div className="flex flex-col justify-between items-center space-x-2 ">
                      <p>
                        The information you provide helps us identify the kind of audience you want to target. If you choose a minimum age under 26, it will be treated as a strict
                        requirement along with location, while all other preferences will be used as guidelines to find the most suitable audience for your ad.
                      </p>

                      <div className="  w-full mt-[30px] pe-2">
                        {/* Gender */}
                        <div>
                          <label className="block text-md font-medium mb-2">Gender</label>
                          <div className=" grid grid-cols-3 gap-2 ">
                            <SelectGroupRadioOptionSingle
                              datas={["All", "Men", "Women"]}
                              value={gender}
                              valueChange={(value) => {
                                setGender(value);
                              }}
                            />
                          </div>
                        </div>

                        {/* Age */}
                        <div className="mt-[30px]">
                          <label className="block text-md font-medium my-2">Age</label>
                          <div className="flex items-center justify-between">
                            <span>{age[0]}</span>
                            <input type="range" min={18} max={65} value={age[0]} onChange={(e) => setAge([parseInt(e.target.value), age[1]])} className="mx-2 w-full" />
                            <span>65+</span>
                          </div>
                          <p className="text-[15px]  mt-1 dark:bg-gray-700 bg-gray-200 px-3 py-2 rounded-md ">
                            When targeting audiences based on factors like gender or interests, only individuals over the age of 18 can be included.
                          </p>
                        </div>

                        {/* Locations */}
                        <div className="mt-[30px]">
                          <label className="block font-semibold mb-2">Locations</label>

                          <TextInput className="py-[30px]" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="Type to add more locations" />
                          {location && (
                            <div className="mt-2 inline-flex items-center bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
                              {location}
                              <button onClick={() => setLocation("")} className="ml-2 text-blue-700 hover:text-red-600">
                                x
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="w-full mt-[30px] pe-2">
                      {/* Duration */}
                      <div>
                        <label className="block font-semibold mb-2">Duration</label>
                        <div className="grid grid-cols-2  gap-4">
                          <div className="flex items-center gap-2 border rounded px-2  py-[15px]">
                            <div className="flex justify-between items-center w-full">
                              <div className="flex flex-col ps-3">
                                <span>
                                  {days} {days === 1 ? "Day" : "Days"}
                                </span>
                              </div>
                              <div className="flex items-center gap-5">
                                <button
                                  disabled
                                  className=" w-8 h-8 cursor-not-allowed rounded-full dark:text-white border border-1 dark:border-white border-black flex items-center justify-center"
                                  onClick={() => setDays((prev) => Math.max(1, prev - 1))}
                                >
                                  <Minus />
                                </button>
                                <button
                                  disabled
                                  onClick={() => setDays((prev) => prev + 1)}
                                  className=" w-8 h-8 cursor-not-allowed rounded-full dark:text-white border border-1 dark:border-white border-black flex items-center justify-center"
                                >
                                  <Plus />
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="">
                            <DatePicker
                              className="py-[40px] "
                              onChange={(value: any) => {
                                setEndDate(value);
                              }}
                              value={endDate}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Daily Budget */}
                      <div className="mt-[30px] mb-[80px]">
                        <label className="block font-semibold mb-2">Daily budget</label>
                        <div className=" border-l-4 border-blue-400 p-3 text-sm rounded">
                          <strong>Introducing daily budget for boosting</strong>
                          <br />
                          Get more control over your ad spend by setting the average amount you want to spend each day.
                        </div>

                        <div className="flex items-center justify-center text-blue-600 text-3xl font-semibold mt-2">
                          $ {budget ? budget.toFixed(2) : "0.00"}
                          <NumberInput className="ml-3 text-base w-20 border px-2 py-1 rounded" value={budget ?? ""} onChange={handleBudgetChange} />
                        </div>
                        {/* <input type="number" min={1} step={0.01} value={budget} onChange={handleBudgetChange} className="ml-3 text-base w-20 border px-2 py-1 rounded" /> */}
                        <input type="range" min={0} max={500} value={budget ?? 0} onChange={(e) => setBudget(parseFloat(e.target.value))} className="w-full mt-4" />
                        {/* <input type="range" min={100} className="w-full mt-4" />
                         */}
                        <div className="flex justify-between text-sm text-gray-500">
                          <span>$1.00</span>
                          <span>$500.00</span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {/* ===========Description Title=============== */}

            <ScrollBar orientation="vertical" />
          </ScrollArea>
          {hideDescription || message ? (
            <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] left-0 w-full">
              <button
                onClick={() => setIsDialogOpen(false)}
                className="w-full mt-6 font-semibold bg-red-500 text-white text-lg py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
              >
                Close
              </button>
            </div>
          ) : (
            <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] left-0 w-full">
              <button
                onClick={() =>
                  showDialogConfirm({
                    // titileButtonSubmit: "Yes, Continue",
                    titileButtonCancel: "No, Cancel",
                    title: "Promote",
                    message: "Do you want to contnue?",

                    onSubmit() {
                      submitRunCampaign(post.provider_post_id);
                    },
                  })
                }
                className="w-full mt-6 font-semibold bg-blue-500 text-white text-lg py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
              >
                {loadingSubmit ? <Loader className="animate-spin" /> : "Promote"}
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

